import {
  Grid,
  GridItem,
  type GridItemProps,
  type GridProps,
  type Integer,
} from 'platform/foundation';
import {match} from 'ts-pattern';

import {type ReactNode} from 'react';

import {isNotNilOrEmpty, type Nullish} from 'shared/web';

/**
 * Keeps net, gross and cost on one row: `GrossPriceField` adds the gross cell only when a VAT rate
 * exists, so the column count follows the rate and the cost permission.
 */
export function PriceRow(props: {
  vatRate: string | Nullish;
  canViewCost: boolean;
  spacing: Integer;
  span?: GridItemProps['span'];
  /** Cells before the price fields, such as a variant's order code. */
  leadingCells?: number;
  /** Devices below this one stack the fields. */
  stackBelow?: 'tablet' | 'notebook';
  children: ReactNode;
}) {
  const fields =
    (props.leadingCells ?? 0) +
    1 +
    (isNotNilOrEmpty(props.vatRate) ? 1 : 0) +
    (props.canViewCost ? 1 : 0);
  const columns = match(props.stackBelow)
    .returnType<NonNullable<GridProps['columns']>>()
    .with('tablet', () => [1, fields])
    .with('notebook', () => [1, 1, fields])
    .with(undefined, () => fields)
    .exhaustive();
  return (
    <GridItem span={props.span}>
      <Grid columns={columns} spacing={props.spacing}>
        {props.children}
      </Grid>
    </GridItem>
  );
}
